import { SEARCH_HC_REQUEST, SEARCH_HC_SUCCESS, SEARCH_HC_FAILURE } from '../constants/bike_model.constants';

export const searchHCRequest = where => ({
    type: SEARCH_HC_REQUEST, where,
});

export const searchHCRequestSuccess = payload => ({
    type: SEARCH_HC_SUCCESS, payload,
});

export const searchHCRequestFailure = error => ({
    type: SEARCH_HC_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/actions/search_hc.actions.js